import { render, staticRenderFns } from "./SelectWholesaleOrderPayments.vue?vue&type=template&id=548491a8"
import script from "./SelectWholesaleOrderPayments.vue?vue&type=script&lang=js"
export * from "./SelectWholesaleOrderPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports